import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1dfd8dea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "empty-dashboard-state form-block"
}

import { computed, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";

import ListItemsWithTableLayout from "@/widgets/layouts/ListItemsWithTableLayout.vue";
import HandlerAccessDenied from "@/shared/base/HandlerAccessDenied.vue";
import TopPreSalePanel from "@/entities/analytics/dashboards/TopPreSalePanel.vue";
import DashboardsViewForm from "@/entities/analytics/dashboards/DashboardsViewForm.vue";

import { useAuthStore } from "@/store/auth/login";
import { useOwnWorkbooksStore } from "@/store/catalog_data/dashboards";
import { Workbook } from "@/store/analytics/dasboards";


export default /*#__PURE__*/_defineComponent({
  __name: 'DemoDashboardsPage',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const authStore = useAuthStore();
const workbooksStore = useOwnWorkbooksStore();

const dashboardsFormRef = ref();
const isDashboardSelected = ref(false);
const isLoading = ref(false);
const selectedWorkbook = ref<Workbook | null>(null);

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(
    ["system:read", "system:edit"],
    ["analytics:read", "analytics:edit"]
  );
});

const pageTitle = computed(() => {
  return selectedWorkbook.value?.dashboards?.[0]?.name || "Демо-дашборды";
});

const selectedWorkbookId = computed(() => {
  return selectedWorkbook.value?.id || null;
});

const selectedDashboardId = computed(() => {
  return selectedWorkbook.value?.dashboards?.[0]?.id || null;
});

const updateDashboardSelection = (selected: boolean) => {
  isDashboardSelected.value = selected;
};

const handleExpandDashboard = () => {
  if (dashboardsFormRef.value) {
    dashboardsFormRef.value.expandDashboard();
  }
};

const resolveWorkbook = async () => {
  isLoading.value = true;
  try {
    await workbooksStore.getItems("", [], true, false, 0, 50, true);

    const availableWorkbooks = workbooksStore.itemList.filter(
      (item) => item.dashboards && item.dashboards.length > 0
    );

    if (availableWorkbooks.length === 0) {
      selectedWorkbook.value = null;
      return;
    }

    const routeWorkbookId = Number(route.params.workbookId);
    const matchedWorkbook = Number.isFinite(routeWorkbookId)
      ? availableWorkbooks.find((item) => item.id === routeWorkbookId)
      : undefined;

    const nextWorkbook = matchedWorkbook || availableWorkbooks[0];
    selectedWorkbook.value = nextWorkbook;

    if (!matchedWorkbook || String(route.params.workbookId) !== String(nextWorkbook.id)) {
      router.replace({
        name: "demoDashboards",
        params: { workbookId: nextWorkbook.id },
      });
    }
  } finally {
    isLoading.value = false;
  }
};

onMounted(resolveWorkbook);

watch(
  () => route.params.workbookId,
  () => {
    resolveWorkbook();
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListItemsWithTableLayout, null, {
    body: _withCtx(() => [
      _createVNode(HandlerAccessDenied, { "is-denied": isDenied.value }, {
        default: _withCtx(() => [
          _createVNode(TopPreSalePanel, {
            "name-dashbords": pageTitle.value,
            "is-dashboard-selected": isDashboardSelected.value,
            onExpandDashboard: handleExpandDashboard
          }, null, 8, ["name-dashbords", "is-dashboard-selected"]),
          (selectedWorkbookId.value && selectedDashboardId.value)
            ? (_openBlock(), _createBlock(DashboardsViewForm, {
                key: `${selectedWorkbookId.value}-${selectedDashboardId.value}`,
                ref_key: "dashboardsFormRef",
                ref: dashboardsFormRef,
                store: _unref(workbooksStore),
                type: "own_workbook",
                "hide-expand-button": true,
                "default-workbook": selectedWorkbookId.value,
                "default-dashboard": selectedDashboardId.value,
                onDashboardSelected: updateDashboardSelection
              }, null, 8, ["store", "default-workbook", "default-dashboard"]))
            : (!isLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Для выбранного воркбука не найдено доступных дашбордов. "))
              : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["is-denied"])
    ]),
    _: 1
  }))
}
}

})